import React, { useContext, useState } from 'react';
import { Select } from 'antd';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { useAccountsHeads } from '../../NecttosComp/APICaller/queryHooks';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdfCollectionReport = async ({ postData, setLoading, setAlert }) => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.post(`/college/reportGeneration/categoryList`, postData, {
			responseType: 'blob',
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (e) {
		throw new Error(
			setLoading(false),
			setAlert({
				type: 'Message',
				text: 'Chack Date / Time / Main account / Sub account',
				show: true,
			}),
		);
	}
};

export const getReports = (params) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/reportGeneration/categoryList', { params: params });
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};
function sumWithKey(data, key) {
	return (data || []).reduce((x, y) => x + y[key], 0);
}
export const CatogoryListData = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [state, setState] = React.useState({
		startDate: '',
		endDate: '',
		startTime: '',
		year: '',
		mainAccount: '',
		subAccount: '',
	});
	const [alert, setAlert] = React.useState({
		type: 'error',
		text: 'This is a alert message',
		show: false,
	});
	const accounts = useAccountsHeads();

	const onCloseAlert = () => {
		setAlert({
			type: '',
			text: '',
			show: false,
		});
	};
	let quaryData = {
		startDate: state?.startDate,
		endDate: state?.endDate,
		year: state?.year,
		collegeId,
	};
	const { data = [], isLoading, refetch } = useQuery('getcatergory', getReports(quaryData));

	// console.log(data.data.data);

	const [loading, setLoading] = useState(false);
	let subAccount = accounts?.data?.subAccounts || [];
	let mainAccount = accounts?.data?.mainAccounts || [];
	if (state?.mainAccount) {
		subAccount = subAccount?.filter((x) => x.mainId === state?.mainAccount);
	}
	const { Option } = Select;

	const exportPdfMutationDateCollectionReport = useMutation(exportPdfCollectionReport);

	const onDateCollectionReport = async () => {
		setLoading(true);
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let postData = {
				startDate: state?.startDate,
				endDate: state?.endDate,
				startTime: state?.startTime,
				year: state?.year,
				mainAccount: state?.mainAccount || '',
				subAccount: state?.subAccount || '',
				collegeId,
			};

			link.download = state?.endDate;
			const pdfData = await exportPdfMutationDateCollectionReport.mutateAsync({ postData, setLoading, setAlert });
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
			link.click();
			setLoading(false);
		} catch (e) {}
	};

	const columns = [
		{
			title: 'SN',
			dataIndex: 'SN',
			render: (_, data, i) => <div>{i + 1}</div>,
		},
		{
			title: 'Class Name',
			dataIndex: 'className',
			key: 'className',
		},
		{
			title: 'Strenth',
			dataIndex: 'strenth',
			key: 'strenth',
		},
		{
			title: 'TC',
			dataIndex: 'inActive',
			key: 'inActive',
		},
		{
			title: 'Active',
			dataIndex: 'active',
			key: 'active',
		},
		{
			title: 'Female',
			dataIndex: 'female',
			key: 'female',
		},
		{
			title: 'Male',
			dataIndex: 'male',
			key: 'male',
		},
		{
			title: 'General',
			dataIndex: 'general',
			key: 'general',
		},
		{
			title: 'OBC',
			dataIndex: 'obc',
			key: 'obc',
		},
		{
			title: 'OEC',
			dataIndex: 'oec',
			key: 'oec',
		},
		{
			title: 'SC',
			dataIndex: 'sc',
			key: 'sc',
		},
		{
			title: 'ST',
			dataIndex: 'st',
			key: 'st',
		},
	];

	subAccount = subAccount.concat({ label: 'All', value: '' });

	const genderColumns = [
		{ title: 'Gender', dataIndex: 'key', key: 'key' },
		{ title: 'Strength', dataIndex: 'strenth', key: 'strenth' },
	];

	const batchGenderColumns = [
		{ title: 'Batch', dataIndex: 'key', key: 'key' },
		{ title: 'Male', dataIndex: 'male', key: 'male' },
		{ title: 'Female', dataIndex: 'female', key: 'female' },
		{ title: 'Total', dataIndex: 'strenth', key: 'strenth' },
	];

	const categoryGenderColumns = [
		{ title: 'Category', dataIndex: 'key', key: 'key' },
		{ title: 'Male', dataIndex: 'male', key: 'male' },
		{ title: 'Female', dataIndex: 'female', key: 'female' },
		{ title: 'Total', dataIndex: 'strenth', key: 'strenth' },
	];

	return (
		<Main title='Category List' height='100%' width='100%'>
			<Header>
				<div className='flex'>
					<Input2 fieldName='Start Date' type='date' state={state} setState={setState} returnKey='startDate' className='w-[10vw]' />
					<Input2 fieldName='End Date' type='date' state={state} setState={setState} returnKey='endDate' className='w-[10vw]' />
					<Input2 fieldName='Year of Admn' type='number' state={state} setState={setState} returnKey='year' className='w-[10vw]' />
					<Button type='refresh' onClick={() => refetch()}>
						View
					</Button>
				</div>
				<div className='flex justify-end'>
					<Button type='excel' onClick={() => refetch()}>
						Excel
					</Button>
					<Button type='pdf' onClick={onDateCollectionReport}>
						PDF
					</Button>
					<Instruction keyId={'catogoryList'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>
			<Body>
				<div className='flex' style={{ width: '100%', height: '100%' }}>
					<div style={{ flex: 3, overflowX: 'auto' }}>
						{isLoading ? (
							<LoadingAnimation dark />
						) : (
							<Table height='100%' width='1100px' className='mt-2'>
								<Thead>
									<Tr>
										{columns.map((item, i) => (
											<Th key={i} width={i === 0 ? '10px' : '100px'} index={i} position={i}>
												{item.title}
											</Th>
										))}
									</Tr>
								</Thead>
								<Tbody height='auto' width='100px'>
									{data?.data?.data?.map((row, rowIndex) => (
										<Tr key={rowIndex} index={rowIndex} position={rowIndex}>
											{columns.map((col, colIndex) => (
												<Td key={colIndex} index={colIndex} width={colIndex === 0 ? '34px' : '100px'} position={colIndex + 1}>
													{col.dataIndex === 'SN' ? rowIndex + 1 : row[col.dataIndex]}
												</Td>
											))}
										</Tr>
									))}
								</Tbody>
							</Table>
						)}
					</div>
					<div style={{ flex: 1, marginLeft: '10px', overflowY: 'auto', maxHeight: '100%' }}>
						<div style={{ marginBottom: '20px' }}>
							<Table height='100%' width='350px'>
								<label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Gender Wise [ {sumWithKey(data?.data?.categorydata, 'strenth')} ]</label>
								<Thead>
									<Tr>
										{genderColumns.map((item, i) => (
											<Th key={i} index={i} position={i} width={'175px'}>
												{item.title}
											</Th>
										))}
									</Tr>
								</Thead>
								<Tbody height='auto' width='100%'>
									{data?.data?.genderdata?.map((item, i) => (
										<Tr key={i} index={i} position={i}>
											{genderColumns.map((col, j) => (
												<Td key={j} index={j} position={j + 1} width={'175px'}>
													{item[col.dataIndex]}
												</Td>
											))}
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
						<div style={{ marginBottom: '20px' }}>
							<Table height='auto' width='350px'>
								<label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Batch - Gender Wise [ {sumWithKey(data?.data?.categorydata, 'strenth')} ]</label>
								<Thead>
									<Tr>
										{batchGenderColumns.map((item, i) => (
											<Th key={i} index={i} position={i} width={'87px'}>
												{item.title}
											</Th>
										))}
									</Tr>
								</Thead>
								<Tbody height='auto' width='100%'>
									{data?.data?.yearWiseGender?.map((item, i) => (
										<Tr key={i} index={i} position={i}>
											{batchGenderColumns.map((col, j) => (
												<Td key={j} index={j} position={j + 1} width={i === 0 ? '90px' : '83px'}>
													{item[col.dataIndex]}
												</Td>
											))}
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
						<div>
							<Table height='auto' width='350px'>
								<label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Category - Gender Wise [ {sumWithKey(data?.data?.categorydata, 'strenth')} ]</label>

								<Thead>
									<Tr>
										{categoryGenderColumns.map((item, i) => (
											<Th key={i} index={i} position={i} width={'87px'}>
												{item.title}
											</Th>
										))}
									</Tr>
								</Thead>
								<Tbody height='auto' width='100%'>
									{data?.data?.categorydata?.map((item, i) => (
										<Tr key={i} index={i} position={i}>
											{categoryGenderColumns.map((col, j) => (
												<Td key={j} index={j} position={j + 1} width={'87px'}>
													{item[col.dataIndex]}
												</Td>
											))}
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
					</div>
				</div>
			</Body>
		</Main>
	);
};
